import './form.css';

const Form = () => {
    return (
        <form className='contact-form'
            action="https://formspree.io/f/mojvdjwa"
            method="post"
        >
            <div className="form-row">
                <div>
                    <label for="name">Name</label>
                    <input type="text" id="name" name="name" required />
                </div>
                <div>
                    <label for="phone">Mobile</label>
                    <input type="tel" id="phone" name="phone" required />
                </div>
            </div>
                        
            <div className="form-row">
                <div>
                    <label for="email">Email</label>
                    <input type="email" id="email" name="email" required />
                </div>
                <div>
                    <label for="suburb">Suburb</label>
                    <input type="text" id="suburb" name="suburb" required />
                </div>
            </div>
                        

            <label for="projectType">Project Type</label>
            <select id="projectType" name="projectType">
                <option value="" disabled selected>Select project type</option>
                <option value="new-bathroom">New Bathroom</option>
                <option value="new-laundry">New Laundry</option>
                <option value="new-kitchen">New Kitchen</option>
                <option value="maintenance">House Maintenance / Repairs</option>
                <option value="other">Other (please describe below)</option>
            </select>

            <label for="budget">Approximate Budget</label>
            <select id="budget" name="budget">
                <option value="" disabled selected>Select range</option>
                <option value="under-5000">Under $5,000</option>
                <option value="5000-10000">$5,000-$10,000</option>
                <option value="10000-20000">$10,000-$20,000</option>
                <option value="over-20000">Over $20,000</option>
            </select>

            <label for="details">Tell us about your project</label>
            <textarea id="details" name="details" placeholder="Brief description, timeline, preferences..." required></textarea>

            <div>
                <button type="submit" className='form-button'>Submit & Request Quote</button>
            </div>
                        
        </form>
    )
}

export default Form;